import { showNotification } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { customAxios } from "lib/axios";

export type ClientInput = {
  name: string;
  email: string;
  phone: string;
  address: string;
  notes?: string;
  managedBy: string;
  description?: string;
};

export type Client = {
  _id: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  notes?: string;
  description?: string;
  org: string;
  managedBy: string;
  createdAt: string;
  updatedAt: string;
};

export type ClientResponse = {
  success: boolean;
  client: Client;
};

const updateClient = async (
  clientId: string,
  clientData: ClientInput
): Promise<ClientResponse> => {
  const response: AxiosResponse<ClientResponse> = await customAxios.patch(
    `/client/${clientId}`,
    clientData
  );
  return response.data;
};

export const useUpdateClient = () => {
  const queryClient = useQueryClient();

  return useMutation<ClientResponse, Error, { id: string; data: ClientInput }>({
    mutationFn: ({ id, data }) => updateClient(id, data),
    onSuccess: async () => {
      showNotification({
        title: "Client updated",
        message: "Client updated successfully",
        color: "green",
      });
      await queryClient.invalidateQueries({ queryKey: ["clients"] });
    },
  });
};
